<mat-dialog-content>
  <p>Para usar esse cupom, seu carrinho deve possuir o valor mínimo de <span>{{data.order_min_total | dynamic: 'currency'}}</span></p>
  
</mat-dialog-content>
<mat-dialog-actions>
  <button (click)="close()">Voltar</button>
</mat-dialog-actions>
